module.exports = __webpack_public_path__ + "img/ALTS_logo_kz2.7c4d8c14.png";